import { Cell } from './Cell'

type Props = {
  guess: string
  cursorPosition: number
  onCellClick: (position: number) => void
}

export const CurrentRow = ({ guess, cursorPosition, onCellClick }: Props) => {
  // Create an array of 5 cells, filling with letters from guess or empty strings
  const cells = Array.from({ length: 5 }, (_, i) => guess[i] || '')

  return (
    <div className="flex justify-center mb-1 max-[375px]:mb-0.5 max-[350px]:mb-0.5 max-[320px]:mb-1">
      {cells.map((letter, i) => (
        <Cell 
          key={i} 
          value={letter} 
          isCursor={i === cursorPosition}
          isClickable={true}
          onClick={() => onCellClick(i)}
        />
      ))}
    </div>
  )
}
